var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "community-selector-overlay",
      on: { click: _vm.handleOverlayClick }
    },
    [
      _c(
        "div",
        {
          staticClass: "community-selector-modal",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-header" },
            [
              _c("h3", [_vm._v("Welcome to Protopia")]),
              _vm._v(" "),
              _vm.closable
                ? _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button close-btn",
                      on: { click: _vm.close }
                    },
                    [_c("md-icon", [_vm._v("close")])],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "label",
                  {
                    staticClass: "input-label",
                    attrs: { for: "community-select" }
                  },
                  [_vm._v("Select your community:")]
                ),
                _vm._v(" "),
                _c(
                  "md-field",
                  [
                    _c(
                      "md-select",
                      {
                        attrs: {
                          name: "community-select",
                          id: "community-select",
                          placeholder: "Choose a community"
                        },
                        model: {
                          value: _vm.selectedCommunity,
                          callback: function($$v) {
                            _vm.selectedCommunity = $$v
                          },
                          expression: "selectedCommunity"
                        }
                      },
                      _vm._l(_vm.communities, function(community) {
                        return _c(
                          "md-option",
                          { key: community.id, attrs: { value: community.id } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(community.name) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-actions" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-raised md-primary save-btn",
                    attrs: { disabled: !_vm.selectedCommunity },
                    on: { click: _vm.saveCommunity }
                  },
                  [_vm._v("\n          SAVE COMMUNITY\n        ")]
                )
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74b8eae8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b8eae8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommunitySelector.vue
// module id = null
// module chunks = 